import React, { useEffect, useState } from 'react';
import Book from '../../../../../Constants/Book';
import { useDispatch, useSelector } from 'react-redux';
import { deleteBookAction, updateBookStatusAction } from '../../../../../module/action/Book';
import ConfirmaModal from '../../../../../Constants/ConfirmModal';

const Books = () => {
  const dispatch = useDispatch();
  const bookData = useSelector(e => e.Book.bookData);
  const deleteBookLoader = useSelector(e => e.Book.deleteBookLoader);
  const [deletePost, setDeletePost] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const showDeleteModal = post => {
    setDeleteModalOpen(true);
    setDeletePost(post);
  };

  const handleDeleteCancel = () => {
    setDeleteModalOpen(false);
    setDeletePost(false);
  };

  const deleteBook = async () => {
    dispatch(
      deleteBookAction(deletePost._id, () => {
        setDeleteModalOpen(false);
        setDeletePost(false);
      })
    );
  };

  useEffect(() => {
    if (!deleteBookLoader) setDeleteModalOpen(false);
  }, [deleteBookLoader]);

  const updateFunction = obj => {
    dispatch(updateBookStatusAction(obj, obj._id));
  };

  return (
    <div className="booksList flex flex-wrap  ">
      {bookData && bookData.length ? (
        bookData.map((a, i) => <Book index={i} data={a} deleteFun={showDeleteModal} updateFunction={updateFunction} />)
      ) : (
        <p className="w-full font-bold mt-14 text-center">Currently there are no books</p>
      )}
      <ConfirmaModal //
        loading={deleteBookLoader}
        open={deleteModalOpen}
        onCancel={handleDeleteCancel}
        title="Do you want to delete this book?"
        content="All post related to this book will be removed"
        cancelText="No"
        okText="Yes, Delete"
        onOk={deleteBook}
      />
    </div>
  );
};

export default Books;
